module.exports = __webpack_public_path__ + "static/media/9.e5e96679.png";